import {Text} from '@dropbox/dig-components/typography';
import {Box} from '@dropbox/dig-foundations';
import {Layout} from 'components/DSYS/Layout';
import {Link} from 'components/DSYS/Link';
import {useEffect} from 'react';

import {logWorkstreamsInteraction, viaState} from './workstreamsAnalytics';

/**
 * /workstreams: the line atop an empty My workstreams, saying so and
 * pointing at what's below it — your nearest team's cards, or Company when
 * there's no team to show. Logs `my_empty_shown` each time it shows (per half
 * and team), the count to weigh the team cards' `nearest_team` section against.
 */
export const MyEmptyIntro = ({
  halfLabel,
  teamName,
  teamCards,
  companyHref,
}: {
  halfLabel: string;
  teamName?: string | null;
  teamCards: number;
  companyHref: string;
}) => {
  useEffect(() => {
    logWorkstreamsInteraction('my_empty_shown', {
      timeframe: halfLabel,
      team_found: Boolean(teamName),
      team_cards: teamCards,
    });
    // Once per showing: a new half or team, not a re-render.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [halfLabel, teamName]);
  return (
    <Box paddingTop="24">
      <Layout.MaxWidth width="reading" inset>
        <Text size="small" color="subtle" tagName="p">
          You&rsquo;re not on any workstreams in {halfLabel}.{' '}
          {teamName ? (
            <>Here&rsquo;s what {teamName} is working on.</>
          ) : (
            <>
              Browse{' '}
              <Link to={companyHref} state={viaState('my_empty_company')}>
                Company
              </Link>{' '}
              to find yours.
            </>
          )}
        </Text>
      </Layout.MaxWidth>
    </Box>
  );
};
